/**
 * seccionesStore.js — secciones de la app que la autoescuela OCULTA, en el SIMULADOR (en memoria, sin backend).
 * Espejo de c_autoescuela_config.modulos_ocultos + SeccionesContext de apps/driving-school (7/10/2026):
 * lo edita la tarjeta «Secciones de la app» de Ajustes de empresa y lo leen el menú lateral, la barra del móvil,
 * la ficha del alumno y SimulatorApp (una página oculta se sustituye por Planificación).
 * Para las demos: «quitamos lo que no uséis». De inicio no se oculta nada. Ficha: docs/features/autoescuela-ocultar-secciones.md
 */
import { useSyncExternalStore } from "react";
import { normalizaOcultas, validaOcultas } from "./seccionesApp";

// Página del simulador → sección ocultable (las de citas/pedidos no cuentan: solo se aplica en autoescuela).
export const SECCION_DE_PAGINA = {
  autoescuelaDashboard: "dashboard",
  chats: "chats",
  examenes: "examenes",
  autoescuelaConexionDgt: "examenes",
  cursos: "cursos",
  cursoEdicion: "cursos",
  pagos: "cobros",
  autoescuelaFacturacion: "cobros",
  flota: "flota",
  fichajes: "fichajes",
};

let _ocultas = [];
const _subs = new Set();
const emit = () => _subs.forEach((fn) => { try { fn(_ocultas); } catch { /* un suscriptor roto no tumba a los demás */ } });

export function getSeccionesOcultas() {
  return _ocultas;
}

/** Guarda como el servidor: { ok } o { error } (las obligatorias y lo desconocido se rechazan). */
export function setSeccionesOcultas(next) {
  const res = validaOcultas(next);
  if (res.error) return { error: res.error };
  _ocultas = res.value;
  emit();
  return { ok: true };
}

export function resetSeccionesOcultas() {
  _ocultas = [];
  emit();
}

function subscribe(fn) {
  _subs.add(fn);
  return () => _subs.delete(fn);
}

export function useSeccionesOcultas() {
  return useSyncExternalStore(subscribe, getSeccionesOcultas, getSeccionesOcultas);
}

/** ¿Se ve la página `page` del simulador? Fuera de autoescuela, siempre. PURA. */
export function paginaVisible(page, ocultas, sector = "autoescuela") {
  if (sector !== "autoescuela") return true;
  const s = SECCION_DE_PAGINA[page];
  return !s || !normalizaOcultas(ocultas).includes(s);
}

/** Quita del menú las páginas ocultas; un grupo sin hijos visibles desaparece y uno sin su página va al primer hijo. PURA. */
// Tarjeta «Profesor (Plan Profesor)» del selector (26/10/2026): el profesor que se paga su agenda no ve
// «Profesores» ni «Conexión con la DGT» (la app real tampoco: es una agenda de una persona).
let _planProfesor = false;
export function setPlanProfesorSim(on) { _planProfesor = !!on; }
export function getPlanProfesorSim() { return _planProfesor; }
const SIN_MENU_PROFESOR = ["autoescuelaProfesores", "autoescuelaConexionDgt"];

export function filtraNavOcultas(items, ocultas, sector = "autoescuela") {
  if (sector === "autoescuela" && _planProfesor) items = items.filter((it) => !SIN_MENU_PROFESOR.includes(it.id));
  if (sector !== "autoescuela" || !ocultas || ocultas.length === 0) return items;
  return items.flatMap((item) => {
    if (!item.children) return paginaVisible(item.id, ocultas) ? [item] : [];
    const children = item.children.filter((c) => paginaVisible(c.id, ocultas));
    if (children.length === 0) return [];
    return [{ ...item, id: paginaVisible(item.id, ocultas) ? item.id : children[0].id, children }];
  });
}
